module.exports = __webpack_public_path__ + "static/media/ic_close_remove_popup.aaf2b97b.svg";